/**
 * Puts the brand on the browser tab while the branded line sheet is open
 * (KP-4545): title "<sheet> | <brand>" and the brand logo as favicon. Returns
 * a function that puts back exactly what was there.
 */

const iconLink = () => document.querySelector("link[rel~='icon']")

const readIcon = link => ({ href: link.getAttribute('href'), type: link.getAttribute('type') })

function setAttr(link, name, value) {
  if (value === null || value === undefined) link.removeAttribute(name)
  else link.setAttribute(name, value)
}

function swapIcon(link, faviconUrl) {
  if (!link || !faviconUrl) return () => {}
  const previous = readIcon(link)
  setAttr(link, 'type', null)
  setAttr(link, 'href', faviconUrl)
  return () => {
    setAttr(link, 'type', previous.type)
    setAttr(link, 'href', previous.href)
  }
}

export function applyDocumentBranding({ title, faviconUrl }) {
  const previousTitle = document.title
  if (title) document.title = title
  const restoreIcon = swapIcon(iconLink(), faviconUrl)
  return () => {
    document.title = previousTitle
    restoreIcon()
  }
}
